import React from "react";
import Navbar from "../components/Navbar";
import About from "../components/About";
import Footer from "../components/Footer";
import MenuTabs from "../components/MenuTabs";
import BackToTop from "../components/BacktoTop";

const HomePage = () => {
  return (
    <>
      <Navbar></Navbar>
      <div role="main">
        <About></About>
        <MenuTabs></MenuTabs>
      </div>
      <Footer></Footer>
      <BackToTop></BackToTop>
    </>
  );
};

export default HomePage;
